import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export default makeStyles<Theme>((theme) =>
  createStyles({
    adornedEnd: {
      paddingRight: theme.spacing(1),
    },
  })
);
